<hr/>

<form [formGroup]="elasticEmailForm">
    <div fxLayout="row wrap" fxLayoutAlign="space-around baseline">
      <p fxFlex="100" [innerHTML]="'COMMON.SOURCE_SETUP.SENDING_CONF.SENDER_EXPLANATION.ELASTIC_EMAIL' | translate"></p>
        <input type="hidden" formControlName="type">
        <mat-form-field appearance="outline" fxFlex="1 1 100%" fxFlex.gt-xs="0 0 calc(50% - 15px)">
          <mat-label>{{ 'COMMON.SOURCE_SETUP.SENDING_CONF.ELASTIC_EMAIL.POOL_NAME' | translate }}</mat-label>
          <input type="text" matInput placeholder="{{ 'COMMON.SOURCE_SETUP.SENDING_CONF.ELASTIC_EMAIL.POOL_NAME_PLACEHOLDER' | translate }}" formControlName="poolName">
        </mat-form-field>
      </div>
</form>
